<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/move-step3')"></span>
    </div>
    <div class="title">是否有大件贵重物品？</div>
    <div class="option-container">

      <div class="item">
        <span class="qty-label">保险箱 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551417471"]' type='1551417471'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">钢琴 <span class="color-grey">/ $210起</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551417480"]' type='1551417480'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">跑步机 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551418035"]' type='1551418035'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">按摩椅 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551418043"]' type='1551418043'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">商用打印机 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1663575190"]' type='1663575190'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">商用冰柜 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1663575217"]' type='1663575217'>
          </v-counter>
        </div>
      </div>


      <div class="item">
        <span class="qty-label">大理石制品 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551418054"]' type='1551418054'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">玻璃易碎品 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551417486"]' type='1551417486'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">其他易碎品 <span class="color-grey">/ $30~$50</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1663575258"]' type='1663575258'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">实木家具 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1663575433"]' type='1663575433'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">三门实木衣柜 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1551417492"]' type='1551417492'>
          </v-counter>
        </div>
      </div>


      <div class="item">
        <span class="qty-label">双开门冰箱 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1663575454"]' type='1663575454'>
          </v-counter>
        </div>
      </div>


      <div class="item">
        <span class="qty-label">麻将机 <span class="color-grey">/ $100</span></span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='tempValuable["1663575412"]' type='1663575412'>
          </v-counter>
        </div>
      </div>

      <div class="weui-cells">
        <div class="weui-cell other-text">
            <div class="weui-cell__bd">
                <input class="weui-input " type="text" placeholder="其他重物（点击填写）" v-model="order.data.move_other_valuables">
            </div>
        </div>
      </div>
    </div>

    <div class="btn-box-fix">
      <div class="btn-container">

        <div class="btn active" @click="checkSubmit()">{{btnText()}}</div>
      </div>
    </div>

    <img :src="pixelURL('move','zhongwu')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'move-step4',
  data () {
    return {
      order:{},
      tempValuable:{
        "1551417471":0,
        "1551417480":0,
        "1551417486":0,
        "1551417492":0,
        "1551418035":0,
        "1551418043":0,
        "1551418054":0,
        "1663575190":0,
        "1663575217":0,
        "1663575258":0,
        "1663575412":0,
        "1663575433":0,
        "1663575454":0
      }
    }
  },
  methods: {
    checkSubmit(){
      this.order.data.move_valuables = this.tempValuable;
      this.orderUpdateAll('/move-step5');
    },
    btnText(){
      if(this.isSkipable()){
          return "下一步";
      }
      else{
          return "跳过"
      }
    },
    isSkipable(){
      if(this.order.data.move_other_valuables){
        return true;
      }
      let obj = this.tempValuable;
      let summary = 0;
      for (let item in obj) {
        summary = summary + obj[item];
      }
      if(summary){
        return true;
      }
      else{
        return false;
      }
    },
    plus: function (type) {
      eval('this.tempValuable["'+type+'"]=this.tempValuable["'+type+'"]+1');
			if(this.tempValuable[type]>20){
				this.tempValuable[type]=20;
			}
		},
    minus: function (type) {
      eval('this.tempValuable["'+type+'"]=this.tempValuable["'+type+'"]-1');
			if(this.tempValuable[type]<0){
				this.tempValuable[type]=0;
			}
		},
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    if(Object.keys(this.order.data.move_valuables).length>0){
      this.tempValuable = this.order.data.move_valuables;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.option-container{
  padding:0 40px;
}
.qty-label{
	display: inline-block;
	font-weight: 100;
	vertical-align: top;
	padding: 12px 0 0 0;
	color: #000;
}
.item{
  display: flex;
	justify-content:space-between;
  align-items:left;
  margin-bottom:6px;
  img{
    width:60px;
  }
  .counter{
    padding-top:8px;
    margin-left:14px;
  }
}

.other-text{
  font-size:0.9em;
  border-left:0.5px solid #e5e5e5;
  border-right:0.5px solid #e5e5e5;
}
.container /deep/ .qty .number{
  width:40px;
}

</style>



// WEBPACK FOOTER //
// src/pages/move/step4.vue